// Helper function to safely get departure airports
export const getDepartureAirports = (airports: any) => {
  if (Array.isArray(airports) && airports.length > 0) {
    return airports.map((airport: any) => airport.value);
  }
  return [];
};

// Helper function to get participants from current query data
export const getParticipants = (currentQueryData: any): any => {
  const roomsParam = currentQueryData?.get("rooms") || "25,25";
  const urlRooms = roomsParam.split(";");

  const cswRooms = urlRooms.map((room: string) => {
    const travellers: number[] = room.split(",").map(Number);
    const adults = travellers.filter((age: number) => age >= 25);
    const children = travellers.filter((age: number) => age < 25);
    return {
      adultsCount: adults.length,
      children: children.map((age: number, index: number) => ({
        age,
        key: `child-${index + 1}`,
      })),
    };
  });

  return {
    rooms: cswRooms,
  };
};

/**
 * Safely converts a value to string, handling objects from CSW that may have
 * id/code properties (e.g. LocationInfo from WegHotelPlace).
 * Returns undefined for null/undefined or unrecognized objects.
 */
export const ensureString = (value: any): string | undefined => {
  if (value == null) return undefined;

  if (typeof value === "object") {
    if ("id" in value) return String(value.id);
    if ("code" in value) return String(value.code);
    if ("value" in value) return String(value.value);
    return undefined;
  }

  return String(value);
};

export const getRoomsFromParticipants = (participants: any) => {
  return participants.rooms
    .map((room: any) =>
      [
        ...Array(room.adultsCount).fill(25),
        ...room.children.map((child: any) => child.age),
      ].join(",")
    )
    .join(";");
};
